import React, { useEffect } from "react";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import BoxNumber from "./Components/BoxNumber";
import SMPRoundList from "../../components/SMP/SMPRoundList";
import RoundCreator from "./Components/RoundCreator";
import LineGenerator from "./Components/LineGenerator";

import { playerListStyles, StyledMatchGrid, StyledProgressBox } from "./styles";

import { getSelectedLeague } from "../../redux/actions/smp-action/get-selected-league";
import {ManualDeclareWinner} from "./ManualDeclareWinner";

const PlayerListSMP = ({ roundsList, noOfPlayers, leagueId }) => {
  const classes = playerListStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedSmpSelector = useSelector(
    (state) => state.getSelectedLeagueReducer
  );

  const handleClick = (value, item, league_id, _id) => {
    if (!item.isWinner) {
      navigate(
        `${
          value == null ||
          item.is_bye != undefined ||
          item.group1 == null ||
          item.group2 == null ||
          item.group1.length < 1 ||
          item.group2.length < 1
            ? "/smp"
            : `/smp/scorecard/${item._id}`
        }`,
        { state: { league_id, _id } }
      );
    }
  };

  const getValueInfo = (value, i) => {
    return value == null || (i >= 1 && value.length == 0)
      ? "TBA"
      : value.length < 1
      ? "BYE"
      : `${value[0]?.name} ${
          value[0].playing_handicap != undefined
            ? `(${value[0]?.playing_handicap})`
            : ""
        }`;
  };

  useEffect(() => {
    if (leagueId != null) dispatch(getSelectedLeague(leagueId));
  }, [leagueId, dispatch]);

  return !selectedSmpSelector.loading ? (
    selectedSmpSelector?.status?.leageData?.length > 0 && (
      <Grid
        sx={{ overflow: "hidden", overflowX: "auto" }}
        container
        spacing={2}
        alignItems="center"
      >
        <Grid
          item
          container
          xs={12}
          spacing={2}
          sx={{ flexWrap: "nowrap", mt: 2 }}
        >
          {roundsList.map((roundItem, index) => (
            <Grid
              key={roundItem.label + '_label'}
              item
              xs={3}
              xl={2}
              sx={{ minWidth: "230px" }}
            >
              <SMPRoundList
                number={noOfPlayers}
                roundItem={roundItem}
                index={index}
              />
            </Grid>
          ))}
        </Grid>

        <Grid
          item
          container
          xs={12}
          spacing={2}
          sx={{ flexWrap: "nowrap", mb: 2 }}
        >
          {selectedSmpSelector?.status?.leageData &&
            selectedSmpSelector.status?.leageData[0]?.rounds?.map(
              (round, roundIndex) => {
                const { matches, league_id, _id } = round;
                return (
                  <StyledMatchGrid key={league_id + '_grid'} item xs={3} xl={2}>
                    {matches?.map((item, idx) => {
                      return Object.entries(item)
                        ?.slice(0, 2)
                        .map(([_, value], index) => {
                          return (
                            <Box
                              className={classes.box}
                              sx={{
                                display:
                                  item.isWinner != undefined &&
                                  index % 2 != 0 &&
                                  item.isWinner &&
                                  item.isWinner &&
                                  "none",
                              }}
                            >
                              <BoxNumber childIndex={index} parentIndex={idx} />
                              <Box

                                className={clsx(
                                  classes.mainBox,
                                  classes.greyBox
                                )}
                                sx={{
                                  background:
                                    (index % 2 == 0 && item.won) == "group1" ||
                                    (index % 2 == 0 &&
                                      item.is_bye != null &&
                                      item.is_bye == "group2")
                                      ? "#06623B"
                                      : ((index % 2 == 1 && item.won) ==
                                          "group2" ||
                                          (index % 2 == 1 &&
                                            item.is_bye != null &&
                                            item.is_bye == "group1")) &&
                                        "#06623B",
                                }}
                              >
                                  {roundIndex !== 0 && item.isWinner == null && <Box sx={{position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)'}}>
                                      <ManualDeclareWinner roundsList={roundsList} value={value} item={item} round={round} />
                                  </Box>}
                                <Box
                                    onClick={() =>
                                        handleClick(value, item, league_id, _id)
                                    }>
                                  <Typography
                                    variant="body2"
                                    className={classes.playerName}
                                  >
                                    {getValueInfo(value, roundIndex)}
                                  </Typography>

                                  {(index % 2 == 0 && item.won) == "group1" ? (
                                    item.sudden_death ? (
                                      <Box
                                        sx={{
                                          fontWeight: 700,
                                          fontSize: "14px",
                                        }}
                                      >
                                        Won in playoff
                                      </Box>
                                    ) : (
                                      <Box sx={{ fontWeight: 700 }}>
                                        {item.autoScoreHoles
                                          ? item.autoScoreHoles
                                          : item?.score_up_value}
                                      </Box>
                                    )
                                  ) : (
                                    (index % 2 == 1 && item.won) == "group2" &&
                                    (item.sudden_death ? (
                                      <Box
                                        sx={{
                                          fontWeight: 700,
                                          fontSize: "14px",
                                        }}
                                      >
                                        Won in playoff
                                      </Box>
                                    ) : (
                                      <Box sx={{ fontWeight: 700 }}>
                                        {item.autoScoreHoles
                                          ? item.autoScoreHoles
                                          : item?.score_up_value}
                                      </Box>
                                    ))
                                  )}
                                  {index % 2 === 0 &&
                                    item.is_bye &&
                                    item.is_bye !== "group1" && (
                                      <>
                                        <Typography
                                          variant="body2"
                                          className={classes.playerName}
                                          sx={{
                                            marginTop: "10px",
                                          }}
                                        >
                                          Won in BYE
                                        </Typography>
                                      </>
                                    )}
                                  {index % 1 === 0 &&
                                    item.is_bye &&
                                    item.is_bye !== "group2" && (
                                      <>
                                        <Typography
                                          variant="body2"
                                          className={classes.playerName}
                                          sx={{
                                            marginTop: "10px",
                                          }}
                                        >
                                          Won in BYE
                                        </Typography>
                                      </>
                                    )}
                                </Box>
                              </Box>

                              {item.isWinner == null && (
                                <LineGenerator
                                  index={index}
                                  roundsList={roundsList}
                                  matches={matches}
                                />
                              )}
                            </Box>
                          );
                        });
                    })}
                  </StyledMatchGrid>
                );
              }
            )}

          <RoundCreator
            selectedSmpSelector={selectedSmpSelector}
            roundsList={roundsList}
          />
        </Grid>
      </Grid>
    )
  ) : !selectedSmpSelector?.loading && selectedSmpSelector?.error ? (
    <>{selectedSmpSelector.status.message}</>
  ) : (
    <StyledProgressBox>
      <CircularProgress color="secondary" />
    </StyledProgressBox>
  );
};

export default PlayerListSMP;
